import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const NonImageList = ({
  key,
  type="image",
  heading=null,
  content=null,
  mediaPosition="left",
  imageLink=null,
  openNewTab=null,
  image=null,
  buttons=null,
  video=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <>
      <div className={ `content-mobile d-flex d-md-none col-12 col-md-8 adv-mwc content-col ${type} media-${mediaPosition} offset-md-4` }>
        <div className="content-inner col-12 col-md-10 col-xl-7 offset-md-1 offset-lg-2">
          {heading &&
            <h2 className={ `content-title ${content ? "orange-dash" : ""} white` }>{ htmlDecode(heading) }</h2>
          }
          {content &&
            <div className="section-content white" dangerouslySetInnerHTML={{ __html: content }} />
          }
          {buttons && buttons.map((button) =>(
            <Link href={ button.link } target={ `${button.openNewTab ? "_blank" : "_self"}` } className="button inverse mr2">{ button.text }</Link>
          ))}
          {type === 'video' &&
            <>
              {video && video.videoSource === 'wistia' &&
                <div className="btn-row d-flex">
                  <div className="inner-btns">
                    <div
                        className={`wistia_embed wistia_async_${video.videoId} popover=true popoverAnimateThumbnail=true popoverContent=link videoFoam=true`}>
                      <a href="#" className="button inverse mr2">Watch the Video</a>
                    </div>
                  </div>
                </div>
              }
            </>
          }
        </div>
      </div>
        <div className={ `col-10 offset-1 offset-md-0 col-md-5 img-col media-${mediaPosition} ${type}` }>
            {type === 'video' &&
            <>
                {video && video.videoSource === 'youtube' &&
                <div className="img-container linked">
                    <div className="play-btn-wrap">
                        <a className="play-btn youtube-modal" data-toggle="modal"
                           data-target={`#video-${video.videoId}`}><span className="fa fa-play"/></a>
                    </div>
                    {video.videoThumbnail.formats?.large &&
                    <img src={video.videoThumbnail.formats.large.url.includes(cdnUrl) ? video.videoThumbnail.formats.large.url : cdnUrl + video.videoThumbnail.formats.large.url}
                         alt={video.videoThumbnail?.alternativeText} className="video-thumb"/>
                    }
                    {!video.videoThumbnail.formats?.large &&
                    <img src={video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url}
                         alt={video.videoThumbnail?.alternativeText} className="video-thumb"/>
                    }
                </div>
                }
                {video && video.videoSource === 'vimeo' &&
                <div className="img-container linked">
                    <div className="play-btn-wrap">
                        <a className="play-btn youtube-modal" data-toggle="modal"
                           data-target={`#video-${video.videoId}`}><span className="fa fa-play"/></a>
                    </div>
                    {video.videoThumbnail.formats?.large &&
                    <img src={video.videoThumbnail.formats.large.url.includes(cdnUrl) ? video.videoThumbnail.formats.large.url : cdnUrl + video.videoThumbnail.formats.large.url}
                         alt={video.videoThumbnail?.alternativeText} className="video-thumb"/>
                    }
                    {!video.videoThumbnail.formats?.large &&
                    <img src={video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url}
                         alt={video.videoThumbnail?.alternativeText} className="video-thumb"/>
                    }
                </div>
                }
                {video && video.videoSource === 'wistia' &&
                <div className="img-container linked">
                    <div className="play-btn-wrap">
                        <a className="play-btn youtube-modal" data-toggle="modal" data-target={ `#video-${video.videoId}` }><span className="fa fa-play" /></a>
                    </div>
                    {video.videoThumbnail.formats?.large &&
                    <img src={video.videoThumbnail.formats.large.url.includes(cdnUrl) ? video.videoThumbnail.formats.large.url : cdnUrl + video.videoThumbnail.formats.large.url} alt={ video.videoThumbnail?.alternativeText } className="video-thumb"/>
                    }
                    {!video.videoThumbnail.formats?.large &&
                    <img src={video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url} alt={ video.videoThumbnail?.alternativeText } className="video-thumb"/>
                    }
                </div>
                }
            </>
            }
            {type === 'image' &&
            <>
                {(imageLink && image) &&
                <Link href={ imageLink } target={ `${openNewTab ? "_blank" : "_self"}` }>
                    <div className="img-container linked">
                        {image.formats?.medium &&
                        <img src={image.formats.medium.url.includes(cdnUrl) ? image.formats.medium.url : cdnUrl + image.formats.medium.url} alt={ image?.alternativeText } />
                        }
                        {!image.formats?.medium &&
                        <img src={image.url.includes(cdnUrl) ? image.url : cdnUrl + image.url} alt={ image?.alternativeText } />
                        }
                    </div>
                </Link>
                }
                {(!imageLink && image) &&
                <div className="img-container">
                    {image.formats?.medium &&
                    <img src={image.formats.medium.url.includes(cdnUrl) ? image.formats.medium.url : cdnUrl + image.formats.medium.url} alt={ image?.alternativeText } />
                    }
                    {!image.formats?.medium &&
                    <img src={image.url.includes(cdnUrl) ? image.url : cdnUrl + image.url} alt={ image?.alternativeText } />
                    }
                </div>
                }
            </>
            }
        </div>
      <div className={ `content-desktop d-none d-md-flex col-md-8 adv-mwc content-col ${type} media-${mediaPosition} offset-md-3` }>
        <div className={`${mediaPosition} ${mediaPosition === "right" ? "content-inner col-12 col-md-6 col-lg-5 col-xl-4 offset-xl-2 offset-lg-1 " : "content-inner col-12 col-md-6 col-lg-5 col-xl-4 offset-md-3 offset-lg-3"}  `}>
          {heading &&
            <h2 className={ `content-title ${content ? "orange-dash" : ""} white` }>{ htmlDecode(heading) }</h2>
          }
          {content &&
            <div className="section-content white" dangerouslySetInnerHTML={{ __html: content }} />
          }
          {buttons &&
            <div className="btn-row d-flex">
              <div className="inner-btns">
                {buttons.map((button) =>(
                  <Link href={ button.link } target={ `${button.openNewTab ? "_blank" : "_self"}` } className="button inverse mr2">{ button.text }</Link>
                ))}
              </div>
            </div>
          }
            {type === 'video' &&
              <>
                {video && video.videoSource === 'wistia' &&
                <div className="btn-row d-flex">
                    <div className="inner-btns">
                        <div
                            className={`wistia_embed wistia_async_${video.videoId} popover=true popoverAnimateThumbnail=true popoverContent=link videoFoam=true`}>
                            <a href="#" className="button inverse mr2">Watch the Video</a>
                        </div>
                    </div>
                </div>
                }
              </>
            }
        </div>
      </div>
    </>
  )
}

export default NonImageList
